import {Directive, ElementRef} from "@angular/core";
import {DocumentService} from "../services/document.service";
import {BusService, INewDocumentEvent} from "../services/bus.service";
declare var $: any;


@Directive({
  selector: "[nvDisabled]"
})
export class NvDisabledDirective {
  private disabledExternal: boolean;


  constructor(private element: ElementRef,
              private busService: BusService) {
    this.disabledExternal = $(this.element.nativeElement).prop("disabled");

    this.busService.onDocumentUpdated
      .subscribe(e => setTimeout(this.onDocumentUpdated.bind(this, e), 1));
  }

  private onDocumentUpdated(e: INewDocumentEvent) {
    if (e.readonly) {
      $(this.element.nativeElement).prop("disabled", true);
    } else {
      if (!this.disabledExternal) {
        $(this.element.nativeElement).prop("disabled", false);
      }
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/directives/nv-disabled.directive.ts